import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { BallotService } from './ballot.service';
import { Ballot, HybridContest, Statement, Choice } from './backend-types';
import '@angular/localize/init';
import { Router } from "@angular/router";
import { ballotListRoute, dashboardRoute, pollDecisionRoute, reviewRoute } from '../route-names';
import { MatDialog } from '@angular/material/dialog';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SessionStorageService } from '../Services/session-storage.service';
import { DeclineAmDialogComponent } from './decline-am-dialog.component';
import { OvalChoiceComponent } from '../choice/oval-choice/oval-choice.component';
import { WriteInChoiceComponent } from '../choice/write-in-choice/write-in-choice.component';
import { ApiAboutService } from '../Services/api-about.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UnrankedChoiceComponent } from '../choice/unranked-choice/unranked-choice.component';
import { RankedChoiceComponent } from '../choice/ranked-choice/ranked-choice.component';
import { DecisionDialogService, DialogType } from '../Services/decision-dialog.service';
import { BallotListService } from '../ballot-list/ballot-list.service';
import { hasHtml } from '../Services/utils';

@Component({
    selector: 'app-ballot',
    templateUrl: './ballot.component.html',
    styleUrls: ['./ballot.component.scss'],
    standalone: false
})
export class BallotComponent implements OnInit, AfterViewInit {
  choicelabel: any
  dataFromDialog: any;
  ballot: Ballot | undefined
  currentContest = this.ballotService.getCurrentContest();
  selectedChoiceCount: number | undefined
  routeName = ""
  submitted = false;
  titlePosition: any;
  @ViewChildren(OvalChoiceComponent) ovalChoiceComponents!: QueryList<OvalChoiceComponent>;
  @ViewChildren(WriteInChoiceComponent) writeInChoiceComponents!: QueryList<WriteInChoiceComponent>;
  @ViewChildren(UnrankedChoiceComponent) unrankedChoiceComponents!: QueryList<UnrankedChoiceComponent>;
  @ViewChildren(RankedChoiceComponent) rankedChoiceComponents!: QueryList<RankedChoiceComponent>;
  @ViewChildren('unrankedOption') unrankedOptions: QueryList<ElementRef> | undefined;
  ovalOnRight: boolean | undefined
  clearWriteins: boolean = false
  jsonWriteInDescriptions: writeInChoiceDescriptions[] = [];
  previosRoute = ""
  //rankedSelections = 0
  maxRankedReached = false

  constructor(
    readonly ballotService: BallotService,
    private readonly ballotListService: BallotListService,
    private readonly router: Router,
    private dialog: MatDialog,
    private announcer: LiveAnnouncer,
    private storer: SessionStorageService,
    public declineDialog: MatDialog,
    readonly about: ApiAboutService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private decisionDialogService: DecisionDialogService,
  ) {
    if (router) {
      this.previosRoute = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString() ?? ""
    }
    this.matIconRegistry.addSvgIcon(
      "up-arrow",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../../assets/images/up-arrow.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "down-arrow",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../../assets/images/down-arrow.svg")
    );
  }

  /////////     G E T T E R S ////////////////////////////////////

  get maxSelect(): number | undefined {
    if(this.ballot?.contest_list[this.currentContest].maxSelect){
      return this.ballot?.contest_list[this.currentContest].maxSelect;
    } else {
      return undefined;
    }
  }

  get minSelect(): number | undefined {
    if(this.ballot?.contest_list[this.currentContest].minSelect) {
      return this.ballot?.contest_list[this.currentContest].minSelect;
    } else {
      return undefined;
    }
  }

  get questionMaxSelect(): number | undefined {
    const maxSelect = this.thisContest?.question?.maxSelect;
    return maxSelect !== undefined ? +maxSelect : undefined;
  }

  get rankedSelectedLenght(): number | undefined {
    return this.thisContest?.rankedStatements.length
  }

  get maxSelectionError(): boolean {
    return (this.selectedChoices?.length ?? 0) > (this.maxSelect ?? 1)
  }

  get minSelectionError(): boolean {
    return (this.selectedChoices?.length ?? 0) < (this.minSelect ?? 0)
  }

  get isUndervote(): boolean {
    const selected = this.selectedChoices?.length ?? 0;
    const max = this.maxSelect ?? 1;
    return selected < max && !this.maxSelectionError && !this.minSelectionError && !this.isDeclineToVoteChoiceSelected;
  }

  get selectedChoices(): Choice[] | undefined {
    return this.thisContest?.choices?.filter(choice => choice.selected)
  }

  get hasDeclineToVoteChoice(): boolean {
    let declineList = this.thisContest?.choices?.filter(choice => choice.declineToVoteChoice);
    if (declineList) {
      return declineList.length > 0;
    }
    else {
      return false;
    }
  }

  get isDeclineToVoteChoiceSelected(): boolean {
    return this.selectedChoices?.some(choice => choice.declineToVoteChoice) ?? false;
  }

  get hasAcclaimedChoice(): boolean {
    let hasNonSelectable = this.thisContest?.choices?.filter(choice => choice.nonSelectable)
    if (hasNonSelectable) {
      return hasNonSelectable.length > 0;
    }
    else {
      return false;
    }
  }

  get thisContest(): HybridContest | undefined {
    return this.ballot?.contest_list[this.currentContest]
  }

  get contest_name(): string {
    return this.thisContest?.description ?? ""
  }
  get rankDescription1(): string {
    return this.thisContest?.description1 ?? ""
  }

  get contestDescriptionJustify(): boolean {
    let justifyText = false
    if (this.thisContest?.description?.length) {
      if (this.thisContest.description.length > 600)
        justifyText = true
    }
    return justifyText
  }

  get description1HasHtml(): boolean {
    if (this.thisContest?.description1) {
      return hasHtml(this.thisContest.description1);
    } else {
      return false
    }
  }

  get description1(): string {
    return this.thisContest?.description1 ?? ""
  }


  get description2(): string {
    return this.thisContest?.description2 ?? ""
  }

  get description2HasHtml(): boolean {
    if (this.thisContest?.description2) {
      return hasHtml(this.thisContest.description2);
    } else {
      return false
    }
  }

  get isWriteinInvalid(): boolean {
    let invalidWriteIn = false;
    this.writeInChoiceComponents?.forEach((writein) => {
      if (writein.writeInForm.dirty && (writein.writeInForm.get('writeInControl')?.invalid == true)) {
        invalidWriteIn = true;
      }
    })
    return invalidWriteIn;
  }
  get rankedHelp() {
    const l1 = $localize`Use the up arrows ("Higher") and down arrows ("Lower") to rank candidates higher and lower, respectively, arranging them in your preferred order. \n`
    const l2 = $localize`Your top choice is ranked "1." \n`
    const l3 = $localize`To unrank a candidate, click the down arrow, or "Lower," until the candidate returns to the "Unranked" section.\n`
    const l4 = $localize`If you reach the maximum number of selections and want to make changes:\n`
    const l5 = $localize`Unrank the candidate to be replaced and make your new selection.`
    return l1 + l2 + l3 + l4 + l5

  }

  get ariaLabelForContest(): string {
    let ariaLabel = $localize`Ballot Office` + (this.currentContest + 1) + $localize`of` +
      this.ballot?.contest_list?.length + this.contest_name + $localize`in list` +
      this.thisContest?.choices?.length + $localize`candidates` + this.description1
    return ariaLabel
  }
  /////////   E N D   G E T T E R S ////////////////////////////////////


  /************      F U N C T I O N S  *********************************/
  ngOnInit() {
    this.ballot = this.ballotService.getBallot()
    if (this.ballot) {
      this.jsonWriteInDescriptions = this.ballotService.getJsonDescrptions()
      this.about.signatureRequired.next(this.ballot.voteEventData?.optionalEventConfiguration?.submitSignature ?? false);
      this.ovalOnRight = this.ballot.voteEventData.optionalEventConfiguration?.ovalOnRight ?? false;
      for (let contest of this.ballot.contest_list) {
        contest.choices?.forEach(choice => {
          choice.selected = contest.selections.includes(choice)
        })
      }
      var saveBallot = () => {
        if (this.ballot) {
          this.storer.setBallot(this.ballot)
          this.storer.setCurrentContest(this.currentContest)
        }
      }
      window.addEventListener("beforeunload", function () {
        saveBallot()
      })
    }
  }

  ngAfterViewInit() {

    this.resetFocus()
    this.announcer.announce($localize`Ballot`, "assertive")
    setTimeout(() => {
      this.routeName = this.router.url
      this.selectAcclaimed()

    });
  }

  onTooltipClick(event: any) {
    event.preventDefault();
  }


  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')

    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
      focusFieldMobile.focus()
    }
  }

  selectAcclaimed() {
    const ballot = this.ballot?.contest_list
    if (ballot) {
      ballot.forEach(contest => {
        contest.choices?.forEach(choice => {
          if (choice.nonSelectable) {
            choice.selected = true
          }
        });
      });
    }
  }

  announce(text: string) {
    this.announcer.announce(text, "polite");
  }


  selectedChoiceEvent(choice: Choice) {

    const contest = this.thisContest
    let choices: Choice[] = []
    if (contest) {
      choices = contest.choices ?? []
    }
    if (choice.declineToVoteChoice && choice.selected) {
      const nonDeclineChecked = this.checkNonDeclinedSelected(choices)
      if (nonDeclineChecked) {
        this.dialogForNonDeclineSelected(choices);
      }
    }
    if (!choice.declineToVoteChoice && choice.selected) {
      const declineChecked = this.checkDeclinedSelected(choices)
      if (declineChecked) {
        this.openDialogForDeclineSelected(choices);
      }
    }
    if (choice.isWriteIn && choice.selected) {
      // TODO *** if any logic related to write-in is needed
    }
  }

  deselectNonDeclined(choices: Choice[]) {
    choices.forEach(choice => {
      if (!choice.declineToVoteChoice) {
        choice.selected = false
      }
    });
  }

  deselectDeclined(choices: Choice[]) {
    choices.forEach(choice => {
      if (choice.declineToVoteChoice) {
        choice.selected = false
      }
    });
  }

  checkDeclinedSelected(choices: Choice[]): boolean {

    let declineSelected: boolean = false
    choices.forEach(choice => {
      if (choice.declineToVoteChoice && choice.selected) {
        declineSelected = true
      }
    });
    return declineSelected
  }

  checkNonDeclinedSelected(choices: Choice[]): boolean {
    let nondeclineSelected: boolean = false
    choices.forEach(choice => {
      if (!choice.declineToVoteChoice && choice.selected) {
        nondeclineSelected = true
      }
    });
    return nondeclineSelected
  }

  dialogForNonDeclineSelected(choices: Choice[]) {
    const dialogRef = this.dialog.open(DeclineAmDialogComponent, {
      disableClose: true,
      data: {
        dialogP1: $localize`Choosing this option records that you have declined to make any selections for `
          + this.thisContest?.description,
        dialogP2: $localize`It will also clear your previous selections on this page.`,
        contest: this.thisContest?.description
      },
      width: '450px'

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deselectNonDeclined(choices)
      }
      else {
        this.deselectDeclined(choices)
      }
    });
  }

  openDialogForDeclineSelected(choices: Choice[]) {
    const dialogRef = this.dialog.open(DeclineAmDialogComponent, {
      disableClose: true,
      data: {
        dialogP1: $localize`You have previously selected Decline to Vote for `
          + this.thisContest?.description
          + $localize` and have now chosen a candidate. `,
        dialogP2: $localize`This action will automatically clear the Decline to Vote selection.`,
        contest: this.thisContest?.description
      },
      width: '450px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deselectDeclined(choices)
      }
      else {
        this.deselectNonDeclined(choices)
      }
    });
  }

  goToReview() {
    let ballot = this.ballot
    if (ballot) {
      for (let contest of ballot.contest_list) {
        if (!contest.isRCV) {
          let choices = contest.choices
          if (choices) {
            contest.selections = choices.filter(choice => choice.selected)
          }
        } else {
          contest.rankedStatements.forEach((statement, statementIndex) => {
            statement.choices.forEach((choice, choiceIndex) => {
              choice.selected = choiceIndex == statementIndex
            })
          })
          contest.unrankedStatements.forEach(unranked => {
            unranked.choices.forEach(choice => choice.selected = false)
          })
        }

      }
    }
    this.router.navigate(reviewRoute);
  }

  next(): void {
    if (!this.maxSelectionError && !this.minSelectionError) {
      if (this.currentContest === (this.ballot?.contest_list.length ?? 0) - 1) {
        this.goToReview();
      }
      else {
        this.resetFocus()
        this.currentContest++;
        setTimeout(() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }, 100);
      }
    }

  }

  previous(): void {
    if (!this.maxSelectionError) {
      this.resetFocus()
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.currentContest--;
    }
  }

  moveUp(ranked: Statement): void {
    let contest = this.thisContest;
    if (contest) {
      let index = contest.rankedStatements.indexOf(ranked);
      if (index !== 0) {
        this.arraymove(contest.rankedStatements, index, index - 1);
        this.disableRankedButtonOne()
        this.announcer.announce(`${ranked.description} moved up.`);
      }

    }
  }

  moveDown(ranked: Statement): void {
    let contest = this.thisContest
    if (contest) {
      let index = contest.rankedStatements.indexOf(ranked)
      if (index === contest.rankedStatements.length - 1) {
        contest.rankedStatements.pop()
        if (ranked.isWriteIn) {
          ranked.description = "Write-In"
        }
        contest.unrankedStatements.push(ranked)
        if (this.maxRankedReached) {
          this.enableRankButtons()
          this.maxRankedReached = false
        }

        this.announcer.announce(`${ranked.description} moved to  unranked options`);
        setTimeout(() => {
          this.focusFirstUnrankedOption();
        }, 100);

      } else {
        this.arraymove(contest.rankedStatements, index, index + 1)
        this.disableRankedButtonOne()
        this.announcer.announce(`${ranked.description} moved down.`);
      }

    }
  }

  rank(unrankedStatement: Statement): void {
    let contest = this.thisContest
    if (contest) {
      contest.rankedStatements.push(unrankedStatement)
      let index = contest.rankedStatements.indexOf(unrankedStatement)

      // if(index == 0){

      // }
      const rankedSelections = contest.rankedStatements.length
      if (rankedSelections == this.questionMaxSelect) {
        this.maxRankedReached = true
        this.disableRankButtons()
      }
      this.announcer.announce(`${unrankedStatement.description} ranked at position ${index + 1} ${rankedSelections} of ${this.questionMaxSelect} ranked`);
      if (contest.unrankedStatements.length === 0) {
        setTimeout(() => {
          this.announcer.announce(`All options have been ranked.`);
        }, 500);
      } else {
        if (!this.maxRankedReached) {
          setTimeout(() => {
            if (!this.maxRankedReached) { }
            this.focusFirstUnrankedOption();
            const remaining = contest?.unrankedStatements.length;
            this.announcer.announce(`There are ${remaining} unranked options remainingin the list.`);
          }, 500);
        } else {
          this.announcer.announce(`${unrankedStatement.description} ranked at position ${index + 1} ${rankedSelections} of ${this.questionMaxSelect} ranked Maximum number of selections reached`);
        }
      }
    }
    this.disableRankedButtonOne()
  }

  focusFirstUnrankedOption(): void {
    const firstUnrankedOption = this.unrankedChoiceComponents.first;
    if (firstUnrankedOption) {
      firstUnrankedOption.getFocus()
    }
  }

  disableRankButtons() {
    this.unrankedChoiceComponents.forEach(button => {
      button.disableRankButton()
    })
  }

  disableRankedButtonOne() {
    setTimeout(() => {
      this.rankedChoiceComponents.forEach(button => {
        button.enableRankUpButtons()
      })
      const firstrankedOption = this.rankedChoiceComponents.first;
      if (firstrankedOption) {
        firstrankedOption.disableRankUpButton()
      }
    });

  }

  enableRankButtons() {
    this.unrankedChoiceComponents.forEach(button => {
      button.enableRankButton()
    })
  }

  trackByFn(index: number, item: any): any {
    return index;
  }

  clearContest(): void {
    let contest = this.thisContest
    if (contest) {
      while (contest.rankedStatements.length > 0) {
        let ranked = contest.rankedStatements.pop()
        if (ranked !== undefined) {
          if (ranked.isWriteIn) {
            ranked.description = "Write-In"
          }
          contest.unrankedStatements.push(ranked)
          this.maxRankedReached = false
          this.enableRankButtons()
        }
      }
      let choices = contest.choices
      if (choices) {
        choices.forEach(choice => choice.selected = false)
        this.ovalChoiceComponents.forEach(choice => choice.clearState())
        this.writeInChoiceComponents.forEach(writeInchoice => writeInchoice.clearState())
        contest.selections = []
      }
    }
    this.announce("All selections were cleared")
  }

  private arraymove(arr: Statement[], fromIndex: number, toIndex: number) {
    var element = arr[fromIndex];
    if (element === undefined) {
      return
    }
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  back() {
    let prompt = $localize`Are you sure you want to leave the ballot?`;
    if(this.ballotService.ballotType === 'POLL') {
      prompt = $localize`Are you sure you want to leave the poll?`;
    }
    const dialogRef = this.decisionDialogService.openDialog(
      DialogType.CONFIRM, prompt,
      $localize`All your selections will be lost.`,
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.about.hasDashboard) {
          if((this.ballotService.ballotType === 'POLL') && (this.ballot !== undefined) && this.ballotListService.canViewPollResults(this.ballot)) {
            this.router.navigate(pollDecisionRoute, {state: {eventId: this.ballot.eventId}})
          } else {
            this.router.navigate(dashboardRoute);
          }
        } else {
          this.router.navigate(ballotListRoute);
        }
      }
    });

  }

  /************   E N D    F U N C T I O N S  *********************************/
}

// choice.model.ts
export interface writeInChoiceDescriptions {
  id: number;
  description: string;
}